import React, { useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import EmailVerification from './emailVerification'
import Register from './register'
import SelfRegister from './selfRegister'
import TermsSettingPage from './termsSettingPage'
import MFASettingPage from './mfaSettingPage'
import Login from './login'
import ForgotPassword from './forgotPassword'
import ConfirmPassword from './confirmPassword'
// import Register from './registration/index'
// import RegistrationConfirmation from './registration/RegistrationConfirmation'
import loginBackground from '../../assets/login/arrows-bright.jpg'
// import ForgotPassword from '../pages/forgotPassword'
// import ConfirmForgotPassword from '../pages/forgotPassword/ConfirmForgotPassword'
import Snackbar from '../../components/Snackbar'
import WelcomeDesktop from './welcome'
import { pageLoadHandler, refreshCurrentCase, showModal } from '../../redux/actions'
import { caseIdSelector } from '../../redux/selectors'
import { ErrorBoundary } from '../../components/ErrorBoundary'
import { compose } from 'recompose'
import withStyles from '@material-ui/core/styles/withStyles'
import ModalContainer from '../../components/ModalContainer'
import RouteWrapper from '../../routes/RouteWrapper'
import LinkHasExpired from './linkHasExpired'

const styles = (theme) => ({
	
	// Set css/scss variables colors, in the same palette as in theme.js
	'@global': {
		':root': {
			'--palette-light': theme.palette.light,
			'--palette-dark': theme.palette.dark,
			'--palette-lightCell': theme.palette.lightCell,
			'--palette-darkCell': theme.palette.darkCell,
			'--palette-blue': theme.palette.blue,
			'--palette-primary-light': theme.palette.primary.light,
			'--palette-primary-A100': theme.palette.primary.A100,
			'--palette-primary-A200': theme.palette.primary.A200,
			'--palette-primary-A300': theme.palette.primary.A300,
			'--palette-primary-main': theme.palette.primary.main,
			'--palette-primary-A500': theme.palette.primary.A500,
			'--palette-primary-A600': theme.palette.primary.A600,
			'--palette-primary-link': theme.palette.primary.link,
			'--palette-primary-A800': theme.palette.primary.A800,
			'--palette-primary-dark': theme.palette.primary.dark,
			'--palette-secondary-light': theme.palette.secondary.light,
			'--palette-secondary-A100': theme.palette.secondary.A100,
			'--palette-secondary-A200': theme.palette.secondary.A200,
			'--palette-secondary-A300': theme.palette.secondary.A300,
			'--palette-secondary-main': theme.palette.secondary.main,
			'--palette-secondary-contrast': theme.palette.secondary.contrast,
			'--palette-secondary-input': theme.palette.secondary.input,
			'--palette-secondary-inputHover': theme.palette.secondary.inputHover,
			'--palette-secondary-additional': theme.palette.secondary.additional,
			'--palette-secondary-A600': theme.palette.secondary.A600,
			'--palette-secondary-A700': theme.palette.secondary.A700,
			'--palette-secondary-A800': theme.palette.secondary.A800,
			'--palette-secondary-dark': theme.palette.secondary.dark,
			'--palette-text-primary': theme.palette.text.primary,
			'--palette-text-secondary': theme.palette.text.secondary,
			'--palette-text-disabled': theme.palette.text.disabled,
			'--palette-text-hint': theme.palette.text.hint,
			'--palette-background-default': theme.palette.background.default,
			'--palette-action-disabledBackground': theme.palette.action.disabledBackground,
			'--palette-action-disabled': theme.palette.action.disabled,
			'--palette-success-main': theme.palette.success.main,
			'--palette-error-main': theme.palette.error.main,
			'--palette-error-light': theme.palette.error.light,
			'--palette-warning-main': theme.palette.warning.main,
			'--palette-info-main': theme.palette.info.main,

		}
	}
})


const Auth = () => {

    const dispatch = useDispatch()
    const caseId = useSelector(caseIdSelector, shallowEqual)

    useEffect(
        () => {
            dispatch(pageLoadHandler('Auth'));
        },
        []
    )

      useEffect(
        () => {
			dispatch(refreshCurrentCase());
        },
        [caseId]
    )

	return (
        <main role="main" className="patient-portal">
			<ErrorBoundary>
				<Switch>
					<RouteWrapper
						exact
						path="/auth/emailVerification"
						component={EmailVerification}
						title="Benchmarc™ | Email Verification"
						gaPageTitle={"Email Verification"}
					/>
					<RouteWrapper
						exact
						path="/auth/register"
						component={Register}
						title="Benchmarc™ | Auth | Register"
						gaPageTitle={"Register"}
					/>
					<RouteWrapper
						exact
						path="/auth/selfRegister"
						component={SelfRegister}
						title="Benchmarc™ | Auth | Self-Register"
						gaPageTitle={"Self-Register"}
					/>
					<RouteWrapper
						exact
						path="/auth/welcome"
						component={WelcomeDesktop}
						title="Benchmarc™ | Auth | Welcome"
						gaPageTitle={"Welcome"}
					/>
					<RouteWrapper
						exact
						path="/auth/terms"
						component={TermsSettingPage}
						title="Benchmarc™ | Auth | Agreement"
						gaPageTitle={"Agreement"}
					/>
					<RouteWrapper
						exact
						path="/auth/mfa"
						component={MFASettingPage}
						title="Benchmarc™ | Auth | 2FA"
						gaPageTitle={"2FA"}
					/>
					<RouteWrapper
						exact
						path="/auth/login"
						component={Login}
						title="Benchmarc™ | Log In"
						gaPageTitle={"Log In"}
					/>
					<RouteWrapper
						exact
						path="/auth/forgotpassword"
						component={ForgotPassword}
						title="Benchmarc™ | Forgot Password"
						gaPageTitle={"Forgot Password"}
					/>
					<RouteWrapper
						exact
						path="/auth/confirmpassword"
						component={ConfirmPassword}
						title="Benchmarc™ | Confirm Password"
						gaPageTitle={"Confirm Password"}
					/>
					<RouteWrapper
						exact
						path="/auth/linkHasExpired"
						component={LinkHasExpired}
						title="Benchmarc™ | The Link Has Expired"
						gaPageTitle={"The Link Has Expired"}
					/>
				</Switch>
            </ErrorBoundary>
			<ModalContainer />
			<Snackbar />
		</main>
	)
}

const enhance = compose(withStyles(styles))

export default enhance(Auth)